<div class="header">
  <p-dropdown [placeholder]="QUESTION_STRINGS.selectTopic"></p-dropdown>
  <p-dropdown [placeholder]="QUESTION_STRINGS.selectLevel"></p-dropdown>
</div>
